import {Component, OnInit} from '@angular/core';
import {WizardPageBaseComponent} from '@utils-lib';
import {FestsetzungVorauszahlungAngaben} from '@nachdigal';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'common-ui-lib-festsetzung-vorauszahlung-angaben',
  templateUrl: './festsetzung-vorauszahlung-angaben.component.html',
  styleUrls: ['./festsetzung-vorauszahlung-angaben.component.scss']
})
export class FestsetzungVorauszahlungAngabenComponent extends WizardPageBaseComponent<FestsetzungVorauszahlungAngaben> implements OnInit {

  static nutzdatenPath = 'festsetzungVorauszahlungAngaben';
  static route = 'festsetzung-vorauszahlung-angaben';

  public showGruendJahrError = true;
  public showFolgeJahrError = true;

  constructor(protected readonly activatedRoute: ActivatedRoute) {
    super(activatedRoute);
  }

  public ngOnInit(): void {
    super.ngOnInit();
    this.checkMandatoryJahre();
  }

  public checkMandatoryJahre(): void {
    this.showGruendJahrError = !(this.data.landForstwirtschaft?.steuerpflichtigerJahrBetriebseroeffnung ||
        this.data.gewerbebetrieb?.steuerpflichtigerJahrBetriebseroeffnung ||
        this.data.selbstaendigerArbeit?.steuerpflichtigerJahrBetriebseroeffnung ||
        this.data.vermietungVerpachtung?.steuerpflichtigerJahrBetriebseroeffnung);

    this.showFolgeJahrError = !(this.data.landForstwirtschaft?.steuerpflichtigerFolgejahr ||
        this.data.gewerbebetrieb?.steuerpflichtigerFolgejahr ||
        this.data.selbstaendigerArbeit?.steuerpflichtigerFolgejahr ||
        this.data.vermietungVerpachtung?.steuerpflichtigerFolgejahr);
  }

  protected getStammdatenMappingRules(): Map<string, unknown | Array<unknown>> {
    return new Map<string, unknown | Array<unknown>>([]);
  }

}
